module.exports = __webpack_public_path__ + "img/laptop.623d5790.png";